/**
 * ML categorization service API.
 * When calling POST /categorize, send the app's current language so the correct
 * model (en or es) is used. Use useTranslation().currentLanguage.
 */
export const ML_SUPPORTED_LANGUAGES = ["en", "es"] as const;
export type MLLanguage = (typeof ML_SUPPORTED_LANGUAGES)[number];

/** Map app locale to ML API language (must match backend SUPPORTED_LANGUAGES). */
export function toMLLanguage(locale: string): MLLanguage {
    const normalized = locale.split("-")[0].toLowerCase();
    return normalized === "es" ? "es" : "en";
}
